import script from "./kalio-email-office-hour.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-email-office-hour.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__